import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { faqs } from "../../data/content";
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-paper px-4 py-16 sm:py-24" data-id="element-147" data-mp="1wpzp6e58xxlh">
      <div className="mx-auto max-w-3xl" data-id="element-148" data-mp="18yu2pg4sw727">
        <SectionHeading tone="light" kicker="Frequently asked questions" title="Your questions, answered" data-id="element-149" data-mp="18zvmc8zvu1vj" />

        <ul className="mt-10 space-y-3" data-id="element-150" data-mp="142n282v6bnrn">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-navy/10" data-id="element-151" data-mp="1dy6vsim9mad8" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left" data-id="element-152" data-mp="2ucgkjduf614l">
                  <span className="text-[17px] font-extrabold leading-snug text-navy" data-id="element-153" data-mp="176gddy29yuyq">{f.q}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? "rotate-45 bg-cta text-ink" : "bg-navy text-white"}`} data-id="element-154" data-mp="1c5jitjm63378">
                    <PlusIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-155" data-mp="ofp6d35rfgni" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-156" data-mp="sgqx0vlm2kdv">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-157" data-mp="x8ior9gi6w5l">
                      <p className="px-5 pb-5 text-base leading-relaxed text-navy/75" data-id="element-158" data-mp="181tzqpe51jv6">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <div className="mt-10" data-id="element-159" data-mp="1hurjszys3gvw">
          <CTAButton label="All clear — I want it now" data-id="element-160" data-mp="1ctu6b0oprb0q" />
        </div>
      </div>
    </section>;
}